module.exports = __webpack_public_path__ + "img/circle-radiation.71fe9c33.svg";